var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.777 7.137h0V7.13a.456.456 0 00-.405-.404h0-.26v-.001h-.005a.456.456 0 00-.405.405h0V16.38a2.845 2.845 0 01-2.854 2.854 2.845 2.845 0 01-2.854-2.854V5.27c0-1.117.91-2.027 2.005-2.006h.002c1.095-.02 2.005.889 2.005 2.006h0l.021 9.432a1.24 1.24 0 01-1.18 1.18 1.24 1.24 0 01-1.178-1.18l.02-7.227h.001V7.47a.456.456 0 00-.405-.404h0-.26 0-.006a.456.456 0 00-.404.404h0v.006l.02 7.227v.001a2.168 2.168 0 002.213 2.212 2.169 2.169 0 002.212-2.212s0 0 0 0l.021-9.433h0C14.06 3.569 12.681 2.19 11 2.19S7.94 3.57 7.919 5.27V16.38c0 2.148 1.76 3.908 3.928 3.93h0c1.076 0 2.063-.474 2.77-1.181a3.881 3.881 0 001.16-2.75V7.138z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4d0dc22e932b3fd4a4f383c3a9c20ec9.svg";
export { ForwardRef as ReactComponent };